module.exports = __webpack_public_path__ + "media/images/flags/16/Oman-8cb37e0659c1630b5d09492f9b783b8e.png";